var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[(_vm.isVideoTypesFetched)?[_c('Form',{attrs:{"fields":_vm.fields,"submit-class":"btn-sm btn-light-blue","submit-text":"Сохранить"},on:{"submit-form":_vm.onSubmit}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }